<template>
  <div class="component-container">
    <div class="top-tab">
      <div
        @click="onTabClick(0)"
        style="margin-left: 0px"
        :class="active === 0 ? 'tab-item-select' : 'tab-item'"
      >
        全部消息
      </div>
      <div
        @click="onTabClick(1)"
        class="notify"
        :class="active === 1 ? 'tab-item-select' : 'tab-item'"
      >
        通知
      </div>
      <div
        @click="onTabClick(2)"
        :class="active === 2 ? 'tab-item-select' : 'tab-item'"
      >
        系统
      </div>
    </div>
    <div class="list-item" v-for="(item, index) in listData" :key="index">
      <div class="item-left">
        <img
          v-if="item.infoType === 2"
          class="image"
          src="@/assets/icon_announcement_message.png"
        />
        <img
          v-else-if="item.infoType === 3"
          class="image"
          src="@/assets/icon_notice_message.png"
        />
        <img v-else class="image" src="@/assets/icon_system_message.png" />
      </div>
      <div class="item-right">
        <div class="right-top">
          <div class="name">
            <span v-if="item.infoType === 2">公告</span>
            <span v-else-if="item.infoType === 3">通知</span>
            <span v-else>系统</span>
          </div>
          <div class="time">{{ item.lastUpdateTime }}</div>
        </div>
        <div class="desc">
          {{ item.content }}
        </div>
      </div>
    </div>
    <pagination
      :total="total"
      layout="total,prev,pager,next"
      :page.sync="listQuery.pageIndex"
      :limit.sync="listQuery.pageSize"
      @pagination="getpaginationList"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { getInfoList } from "@/api/accountcenter";
export default {
  name: "SystemMessage",
  components: { Pagination },
  data() {
    return {
      active: 0,
      listData: [],
      total: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 5,
      },
    };
  },
  mounted() {
    this._getInfoList();
  },
  methods: {
    onTabClick(index) {
      this.active = index;
      this._getInfoList();
    },
    getpaginationList() {
      this._getInfoList();
    },
    _getInfoList() {
      let infoType = -1;
      if (this.active === 0) {
        infoType = -1;
      } else if (this.active === 1) {
        infoType = 3;
      } else {
        infoType = 1;
      }
      getInfoList({ infoType, ...this.listQuery })
        .then((res) => {
          const {
            data: { data, totalCount },
          } = res;
          this.listData = [...data];
          this.total = totalCount;
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.component-container {
  width: 1040px;
  height: 650px;
  background-color: #ffffff;
  padding-left: 20px;
  padding-right: 20px;
  .top-tab {
    font-size: 18px;
    color: #333333;
    display: flex;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #eeeeee;
    .tab-item,
    .tab-item-select {
      border-bottom: 4px solid #ffffff;
      margin-left: 46px;
      cursor: pointer;
    }
    .tab-item-select {
      border-bottom: 4px solid #1082ff;
      color: #1082ff;
    }
    .notify {
      margin-left: 91px;
    }
  }
  .list-item {
    display: flex;
    border: 1px solid #eeeeee;
    margin-top: 20px;
    align-items: center;
    padding: 20px;
    .item-left {
      .image {
        width: 40px;
        vertical-align: middle;
        height: 40px;
      }
    }
    .item-right {
      margin-left: 8px;
      .right-top {
        display: flex;
        align-items: center;
        .name {
          font-size: 14px;
          color: #333333;
        }
        .time {
          margin-left: 10px;
          font-size: 12px;
          color: #999999;
        }
      }
      .desc {
        text-align: left;
        margin-top: 3px;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountcenter/components/systemmessage.vue